<template>
  <div>
    <t-form style="padding-bottom: 30px;">
      <t-form-item label="可拖拽">
        <t-switch v-model="attribute.draggable" :label="['开', '关']" size="small"/>
      </t-form-item>
<!--      <t-form-item label="布局方式">
        <t-select v-model="attribute.layout" size="small">
          <t-option label="自定义" value="custom"/>
          <t-option label="自动" value="auto"/>
          <t-option label="层次布局" value="dagre"/>
          <t-option label="环形布局" value="circular"/>
          <t-option label="网格布局" value="grid"/>
          <t-option label="力导向布局" value="gForce"/>
          <t-option label="辐射型布局" value="radial"/>
        </t-select>
      </t-form-item>
      <t-form-item label="排列方向" v-show="attribute.layout === 'dagre'">
        <t-select v-model="attribute.rankdir" size="small">
          <t-option label="从上到下" value="TB"/>
          <t-option label="从下到上" value="BT"/>
          <t-option label="从左到右" value="LR"/>
          <t-option label="从右到左" value="RL"/>
        </t-select>
      </t-form-item>-->
      <t-button @click="G6EditorShow" block >编辑关系图</t-button>
    </t-form>
    <gallery ref="gallery" @confirmCheck="confirmCheck"/>
    <G6Editor ref="g6Editor" @confirm="confirmEdit" :data="g6Data"/>
  </div>

</template>

<script>

import Gallery from "@/components/designer/gallery";
import G6Editor from "@/views/g6eidtor/g6-editor";

export default {
  name: "cpt-g6-dom-option",
  components: {G6Editor, Gallery},
  props: {
    attribute: Object,
    cptDataForm: Object
  },
  data(){
    return {
      currIndex: -1,
      test:{},
      g6Data:null
    }
  },
  created() {
    this.g6Data = JSON.parse(this.cptDataForm.dataText)
  },
  methods:{
    G6EditorShow(){
      this.$refs.g6Editor.opened();
    },

    showGallery(index){
      this.currIndex = index;
      this.$refs.gallery.opened();
    },
    confirmCheck(fileUrl){
      this.attribute.data.nodes[this.currIndex].img = fileUrl;
    },
    confirmEdit(g6Data){
      this.attribute.refreshFlag = !this.attribute.refreshFlag;//监听刷新
      this.cptDataForm.dataText = JSON.stringify(g6Data)
    }
  }
}
</script>

<style scoped>
</style>